import {Observable, timer} from 'rxjs';
import {map, switchMap}    from 'rxjs/operators';
import {TestScheduler}     from 'rxjs/testing';

import IPlaybackQuality from '../../../../Solutions/Shared/Interfaces/IPlaybackQuality';
import ISolution        from '../../../../Solutions/Shared/Interfaces/ISolution';

const POLL_SOLUTION_QUALITY_INTERVAL = 500;

/**
 * Emits with the latest quality data from the attached solution
 * every 500ms.
 */

const createPlaybackQualityStream = (
    solution: ISolution,
    scheduler?: TestScheduler
): Observable<IPlaybackQuality> =>
    timer(0, POLL_SOLUTION_QUALITY_INTERVAL, scheduler)
        .pipe(
            switchMap(() => solution.getBitrate()),
            map(bitrate => {
                const {resolution, estimatedBandwidth} = solution.state;

                return {
                    bitrate,
                    resolution,
                    estimatedBandwidth
                };
            })
        );

export default createPlaybackQualityStream;